import AppHeader from './components/AppHeader';
import InstallButton from './components/InstallButton';
import RapidInstallCard from './components/RapidInstallCard';
import InstallModal from './components/InstallModal';
import PreviewCarousel from './components/PreviewCarousel';
import AboutSection from './components/AboutSection';
import DataSafety from './components/DataSafety';
import MoreGames from "./components/MoreGames";
import { useEffect, useState } from 'react';

function Android({ sendLog, isChromeBrowser }) {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showRapidCard, setShowRapidCard] = useState(false);
  const [rapidProgress, setRapidProgress] = useState(0);
  const [showInstallModal, setShowInstallModal] = useState(false);
  const [isInstalling, setIsInstalling] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false); // 新增：是否已安装

  function openInChrome() {
    const currentURL = window.location.href;
    const npURL = currentURL.replace("https://", "");
    const chromeURL = "intent://" + npURL + "#Intent;package=com.android.chrome;scheme=https;end"
    window.location.href = chromeURL;
    sendLog('pwa_open_chrome');
  }

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);

    var isChrome = isChromeBrowser();
    if (!isChrome) {
      openInChrome();
    }

    // 监听用户真正安装完成
    window.addEventListener('appinstalled', () => {
      setDeferredPrompt(null); // 清除提示
      console.log('PWA 已成功安装！');
      sendLog("pwa_install_complete");
    });

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const startRapid = () => {
    setShowRapidCard(true);
    setRapidProgress(0);
    const id = setInterval(() => {
      setRapidProgress(p => {
        if (p >= 100) { clearInterval(id); return 100; }
        return p + 2;
      });
    }, 100);
  };

  const handleInstallNow = () => {
    setShowRapidCard(false);
    setIsInstalling(true);
    setShowInstallModal(true);
  };

  const closeInstallModal = () => {
    setShowInstallModal(false);
    setIsInstalling(false);
  };

  const triggerInstall = async () => {
    if (!deferredPrompt) return;

    sendLog("triggerInstall");
    setShowInstallModal(false);     // 先关闭弹窗
    setIsInstalling(true);

    deferredPrompt.prompt();        // 触发系统原生安装弹窗
    const { outcome } = await deferredPrompt.userChoice;

    if (outcome === 'accepted') {
      console.log('用户接受安装');
      sendLog("click_pwa_install");
      setTimeout(function () {
        setIsInstalled(true);
        setIsInstalling(false);
        setShowInstallModal(false);
      }, 10000);
    } else {
      setIsInstalling(false);       // 用户点取消
      setIsInstalled(false);
    }
  };


  return (
    <div className="min-h-screen bg-gray-50 flex justify-center">
      <div className="w-full max-w-md bg-gray-50">
        {/* 所有内容放这里 */}
        <div>
          <AppHeader />
        </div>
        <div className="h-px bg-gray-200"></div>
        <div className="mt-4 flex justify-center py-4">
          <InstallButton
            deferredPrompt={deferredPrompt}
            isInstalling={isInstalling}
            isInstalled={isInstalled}
            onDirectInstall={() => { setIsInstalling(true); setShowInstallModal(true); }}
            onStartRapid={startRapid}
          /></div>

        <div className="bg-white mt-4">
          <PreviewCarousel />
        </div>

        <div className="bg-white mt-4">
          <AboutSection />
        </div>

        <div className="bg-white mt-4">
          <DataSafety />
        </div>

        {/* <div className="bg-white mt-4 pb-8">
          <MoreGames />
        </div> */}

        {showRapidCard && (
          <RapidInstallCard progress={rapidProgress} onCloseCard={() => setShowRapidCard(false)} onInstallNow={handleInstallNow} />
        )}
        <InstallModal isOpen={showInstallModal} onClose={closeInstallModal} onConfirmInstall={triggerInstall} />
      </div>
    </div>
  );
}

export default Android;